import { Pipe, PipeTransform } from '@angular/core';

/**
 * get timezone abbreviation of given date, respecting daylight savings for that date. Relys on browser date.
 *
 * Examples:
 *  new Date(2017, 1, 1) => "EST"
 *  new Date(2017, 4, 12) => "EDT"
 *  new Date(2017, 4, 12) => "GMT-0500" if on a browser that doesn't support timezone abbreviations
 */
@Pipe({
  name: 'wlTimeZoneAbbr',
  pure: true,
  standalone: false
})
export class WlTimeZoneAbbrPipe implements PipeTransform {
  /**
   * get timezone abbreviation of given date
   * @param value
   */
  transform(value: Date): string {
    if (!value) return '';
    let timezoneStr: string = '';

    try {
      const formatter = new Intl.DateTimeFormat('en', {
        timeZoneName: 'short'
      });

      const parts = formatter.formatToParts(value);
      const timeZonePart = parts.find(part => part.type === 'timeZoneName');

      if (timeZonePart && timeZonePart.value) {
        return timeZonePart.value;
      }

      const dateStr = value.toString();
      const match = dateStr.match(/\(([A-Z]{3,4})\)$/);
      if (match && match[1]) {
        return match[1];
      }

      let timezoneOffsetMinutesTotal = value.getTimezoneOffset();
      let timezoneOffsetHours = Math.floor(Math.abs(timezoneOffsetMinutesTotal) / 60);
      let timezoneOffsetMinutes = Math.abs(timezoneOffsetMinutesTotal) % 60;

      timezoneStr = 'GMT';
      timezoneStr += timezoneOffsetMinutesTotal <= 0 ? '+' : '-';
      timezoneStr += (timezoneOffsetHours < 10 ? '0' : '') + timezoneOffsetHours;
      timezoneStr += (timezoneOffsetMinutes < 10 ? '0' : '') + timezoneOffsetMinutes;
    } catch (e) {
      console.error(e);
    }

    return timezoneStr;
  }
}
